import AccordionItem from 'components/shared/BaseAccordion/AccordionItem/AccordionItem';
import { getIdFromText } from 'utils/formatters';
import { ToggleProps } from 'libs/contentful/props';

import { liveUpdateAttrs } from 'libs/contentful/utils';
import { cn } from '@/utils/styles';

const Toggle = ({ sys, tabCopy, accordionItems }: ToggleProps) => {
  return (
    <div
      className={`panel mt-6 md:mt-14`}
      id={`panel-${getIdFromText(tabCopy)}`}
      {...liveUpdateAttrs(sys?.id, 'content')}>
      {accordionItems.items?.map((item, i) => (
        // We intentionally do not pass isFirstElement as a prop to AccordionItem because
        // we do not want the first item to be open by default for the Toggle component
        <AccordionItem
          sectionName={item.sectionName}
          sys={item.sys}
          accordionLabelRte={item.accordionLabelRte}
          accordionCopy={item.accordionCopy}
          key={`accordion-item-${i}`}
          className={cn(
            `open:dark-green-colorway in-cw-dark-colorways:open:light-green-colorway`,
            `open:rounded-md open:mb-2 px-6 open:p-6 md:open:-mx-6 md:px-0 open:[&_td]:text-[unset]`,
          )}
          showSimpleListStyle
        />
      ))}
    </div>
  );
};

export default Toggle;
